import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Stack,
  Chip,
  CardActions,
} from '@mui/material';

function DocumentCard({ document, onClick = () => undefined }) {
  const { image, title, description, version, tags } = document;

  return (
    <Card
      onClick={() => onClick(document)}
      variant="outlined"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        transition: 'transform 0.2s ease-in-out',
        '&:active': {
          transform: 'scale(0.95)',
        },
      }}>
      <CardMedia
        component="img"
        height="140"
        image={image}
        alt={title}
        sx={{ objectFit: 'cover' }}
      />

      <CardContent sx={{ flex: 1 }}>
        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1 }}
          noWrap>
          {description}
        </Typography>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          {(tags || []).slice(0, 3).map(t => (
            <Chip key={t} size="small" label={t} />
          ))}
        </Stack>
      </CardContent>

      {version && (
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Stack alignItems="flex-end">
            <Chip color="primary" size="small" label={`${version}`} />
          </Stack>
        </CardActions>
      )}
    </Card>
  );
}

export default DocumentCard;
